module.exports = __webpack_public_path__ + "static/media/lsd.4439d5c9.png";